import { AnalyticsEventTopic } from '~/modules/analytics/analyticsHelper';
import {
    AI_LISTING_CARD_ELEMENT_TYPE,
    AI_RELATED_SEARCH_ELEMENT_TYPE,
    AI_RELATED_SEARCHES_ELEMENT_NAME,
    AI_SEARCH_PILL_ELEMENT_TYPE,
    AI_SUMMARY_ELEMENT_NAME,
} from './aiSearchConstants';
import {
    determinePageType,
    getAppType,
    getListingAppCost,
    getQueryStringValue,
    isAiAssetListing,
} from './gtmEventTypeHelper';
import { GA4AiContentImpressionEvent, GtmEventType } from './gtmEventType';

interface AiImpressionListing {
    listingId?: string;
    listingName?: string;
    listingType?: string;
    listingUrl?: string;
    pricing?: string;
}

interface AiContentImpressionEvent {
    topic: string;
    elementType: string;
    keyword?: string;
    elementTitle?: string;
    listing?: AiImpressionListing;
}

export class GtmAiContentImpressionType extends GtmEventType {
    // @ts-expect-error * Automated Type Error Fix
    canHandle(event): boolean {
        return (
            event.topic === AnalyticsEventTopic.ANALYTICS_SHOWN_IMPRESSION &&
            (event.elementType === AI_LISTING_CARD_ELEMENT_TYPE || event.elementType === AI_RELATED_SEARCH_ELEMENT_TYPE)
        );
    }

    getBody(event: AiContentImpressionEvent): GA4AiContentImpressionEvent {
        const isPill = event.elementType === AI_RELATED_SEARCH_ELEMENT_TYPE;
        return {
            event: 'custEv_contentImpression',
            element_name: isPill ? AI_RELATED_SEARCHES_ELEMENT_NAME : AI_SUMMARY_ELEMENT_NAME,
            element_title: event.elementTitle || '',
            element_type: isPill ? AI_SEARCH_PILL_ELEMENT_TYPE : 'tile',
            lp_detail_interaction: false,
            featured: false,
            recommended: false,
            ignore_hover: true,
            internal_article: false,
            hover_intent: false,
            page_type: determinePageType(window.location.href),
            search_term: event.keyword || '',
            ...(isPill ? {} : this.getListingProperties(event.listing)),
        };
    }

    private getListingProperties(listing?: AiImpressionListing): Partial<GA4AiContentImpressionEvent> {
        const listingUrl = listing?.listingUrl || undefined;
        return {
            listing_id: listing?.listingId || undefined,
            listing_name: listing?.listingName || undefined,
            listing_type: listing?.listingType || undefined,
            listing_url: listingUrl,
            app_cost:
                listing?.pricing || isAiAssetListing(listing?.listingId, listing?.listingType)
                    ? getListingAppCost(listing?.pricing, listing?.listingId, listing?.listingType)
                    : undefined,
            app_type: listing?.listingType ? getAppType(listing.listingType) : undefined,
            internal_source: (listingUrl && getQueryStringValue(listingUrl, 'channel')) || undefined,
        };
    }
}
